import { oz } from '@weft/utils';

export const ConfirmationCodeSchema = oz.string().length(6).openapi('ConfirmationCode');

export type ConfirmationCode = oz.infer<typeof ConfirmationCodeSchema>;